import { PDFDesignLayers } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

const object = 'PDF Design Layer'
const page = PDFDesignLayers

export const ViewPDFDesignLayer = Simple({
  id: '66efb37a-ee09-4263-b271-9e84ba8f34ec',
  action: 'View',
  object,
  page,
})

export const EditPDFDesignLayer = Simple({
  id: '31372572-0bd8-46a8-a364-f507f0d681b2',
  action: 'Edit',
  object,
  page,
})

export type PDFDesignLayerPermission =
  | typeof ViewPDFDesignLayer
  | typeof EditPDFDesignLayer
